import { render, staticRenderFns } from "./hardwareVideoDetail.vue?vue&type=template&id=d2010fc4&scoped=true&"
import script from "./hardwareVideoDetail.vue?vue&type=script&lang=js&"
export * from "./hardwareVideoDetail.vue?vue&type=script&lang=js&"
import style0 from "./hardwareVideoDetail.vue?vue&type=style&index=0&id=d2010fc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2010fc4",
  null
  
)

export default component.exports